/// <amd-module name="VSSUI/Components/ResizeGroup/ResizeGroup" />
import * as React from "react";
import { ObservableArray, ObservableValue } from "VSS/Core/Observable";
import { ResponsiveLayout } from "VSSUI/ResponsiveLayout";
import { IMenuItem } from "../Menu/Menu.Props";
import { IResizeGroupContext, IResizeGroupProps } from "./ResizeGroup.Props";

export const ResizeGroupContext = React.createContext<IResizeGroupContext>({});

interface IResizeGroupState {
    hiddenCount: ObservableValue<number>;
    overflowItems: ObservableArray<IMenuItem>;
    editedItems: IMenuItem[];
}

export class ResizeGroup extends React.Component<IResizeGroupProps, IResizeGroupState> {
    public constructor(props: IResizeGroupProps) {
        super(props);
        const extraItems = this.props.extraItems || [];
        this.state = {
            hiddenCount: new ObservableValue<number>(0),
            overflowItems: new ObservableArray<IMenuItem>([...extraItems]),
            editedItems: []
        };
    }

    public static getDerivedStateFromProps(nextProps: IResizeGroupProps, prevState: IResizeGroupState): IResizeGroupState {
        ResizeGroup.updateOverflowItems(nextProps, prevState);
        return prevState;
    }

    public render(): JSX.Element {
        return (
            <ResizeGroupContext.Provider value={{ overflowItems: this.state.overflowItems }}>
                <ResponsiveLayout {...this.props.responsiveLayoutProps} onLayoutChange={this.onLayoutChange}>
                    {this.props.children}
                </ResponsiveLayout>
            </ResizeGroupContext.Provider>
        );
    }

    private onLayoutChange = (hiddenCount: number) => {
        this.state.hiddenCount.value = hiddenCount;
        if (this.props.responsiveLayoutProps.onLayoutChange) {
            this.props.responsiveLayoutProps.onLayoutChange(hiddenCount);
        }
        ResizeGroup.updateOverflowItems(this.props, this.state);
    };

    private static updateOverflowItems(props: IResizeGroupProps, state: IResizeGroupState) {
        const extraItems = props.extraItems || [];
        state.overflowItems.value = [...extraItems, ...props.overflowMenuItems.slice(0, state.hiddenCount.value)];
        if (props.useAriaLabelForOverflow) {
            // clear out previously edited menu items text values
            state.editedItems.forEach(item => (item.text = ""));
            state.editedItems = [];
            state.overflowItems.value.forEach(item => {
                if (!item.text && item.ariaLabel) {
                    item.text = item.ariaLabel;
                    state.editedItems.push(item);
                }
            });
        }
    }
}
